<script setup lang="ts">
// The incoming-call screen (HRTH-163): who's calling and where, Accept and Decline. Shown
// while the ring store has a ring for this device; it rings until answered here or on
// another device, declined, the call empties, or the ring times out.
import { useRing } from '../stores/ring'
import Avatar from './Avatar.vue'
import Icon from './Icon.vue'

const ring = useRing()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="ring.incoming && ring.caller"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="alertdialog"
      aria-modal="true"
      :aria-label="`Incoming call from ${ring.caller.name}`"
      data-testid="incoming-call"
    >
      <div class="panel flex w-full max-w-xs flex-col items-center gap-4 p-6 text-center">
        <div class="mono tracking-[0.14em] text-text-muted uppercase">Incoming call</div>
        <Avatar :id="ring.incoming.from" :name="ring.caller.name" :size="72" />
        <div class="min-w-0">
          <div class="truncate text-lg" data-testid="incoming-call-from">{{ ring.caller.name }}</div>
          <div v-if="ring.caller.where" class="truncate text-sm text-text-muted">{{ ring.caller.where }}</div>
        </div>
        <div class="flex w-full gap-2">
          <button class="btn-danger flex-1 max-md:h-11" data-testid="incoming-call-decline" @click="ring.decline()">Decline</button>
          <button class="btn-primary flex-1 max-md:h-11" data-testid="incoming-call-accept" @click="ring.accept()">
            <Icon name="phone" />
            Accept
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
